import { render, staticRenderFns } from "./Ver.vue?vue&type=template&id=4005b6a6&scoped=true"
import script from "./Ver.vue?vue&type=script&lang=js"
export * from "./Ver.vue?vue&type=script&lang=js"
import style0 from "./Ver.vue?vue&type=style&index=0&id=4005b6a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4005b6a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4005b6a6')) {
      api.createRecord('4005b6a6', component.options)
    } else {
      api.reload('4005b6a6', component.options)
    }
    module.hot.accept("./Ver.vue?vue&type=template&id=4005b6a6&scoped=true", function () {
      api.rerender('4005b6a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organizacion/series-documentales/Ver.vue"
export default component.exports